<template>
  <svg
    width="34"
    height="33"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.479 5.37958C30.479 5.37958 26.2549 14.8883 8.16238 11.765C-9.5849 8.7015 29.9938 -1.39692 29.1002 19.1218C28.7733 26.6307 24.6204 31.8229 5.14963 27.4505"
      stroke="#B1A8D3"
      stroke-width="5.96343"
      stroke-miterlimit="10"
    />
    <path
      d="M4.52395 12.563C4.52395 12.563 3.91773 22.1352 4.16033 26.5221"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.6595 23.1988H20.8365C18.9944 23.1988 17.5015 21.5618 17.5015 19.5431C17.5015 17.5238 18.9949 15.8873 20.8365 15.8873H28.6595"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.2613 21.138C22.0652 21.138 22.7169 20.4236 22.7169 19.5424C22.7169 18.6612 22.0652 17.9468 21.2613 17.9468C20.4574 17.9468 19.8057 18.6612 19.8057 19.5424C19.8057 20.4236 20.4574 21.138 21.2613 21.138Z"
      fill="#462170"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.30305 11.0917L6.56435 5.74602C6.38483 4.44844 7.19924 3.23698 8.38301 3.0402L20.5068 1.02718C21.6906 0.830406 22.7958 1.72313 22.9753 3.02071L24.0128 10.4372"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.0449 3.81351L6.71387 6.52722L7.22765 10.2424L23.5587 7.52866L23.0449 3.81351Z"
      fill="#462170"
      stroke="#462170"
      stroke-width="1.56123"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.4788 5.37958C30.4788 5.37958 26.2547 14.8883 8.16219 11.765C6.08602 11.4067 4.79443 10.9522 4.13086 10.4612"
      stroke="#B1A8D3"
      stroke-width="5.96343"
      stroke-miterlimit="10"
    />
  </svg>
</template>
